module.exports = __webpack_public_path__ + "static/media/hill.093dd47a.jpg";